/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const textColor = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M13.23 15h1.9L11 4H9L5 15h1.88l1.07-3h4.18zm-1.53-4.54H8.51L10 5.6z" />
	</SVG>
);

export default textColor;
